interface ActionTypes {
  GET_SITE_APPS_START: string;
  GET_SITE_APPS_SUCCESS: string;
  GET_SITE_APPS_FAILURE: string;
}

export const SiteActionTypes: ActionTypes = {
  GET_SITE_APPS_START: '@@GET_SITE_APPS_START',
  GET_SITE_APPS_SUCCESS: '@@GET_SITE_APPS_SUCCESS',
  GET_SITE_APPS_FAILURE: '@@GET_SITE_APPS_FAILURE'
};

export interface SiteState {
  apps: any[];
  isLoadingApps?: boolean;
  loadAppError?: string;
}
